import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { PencilIcon, TrashIcon } from '../../../../../ui/icons/icons';
import { Permission } from '../../../../../utils/helpers/permissions';
import PermissionGate from '../../../../../utils/hooks/PermissionGate';
import { UserRole } from '../../../../../utils/types/admin_types';

type RoleRowProp = {
  role: UserRole;
  deleteRole: (id: string) => void;
  onEditClick: (role: UserRole) => void;
};

export const RoleRow = ({
  role,
  deleteRole,
  onEditClick,
}: RoleRowProp) => {
  return (
    <TableRow
      hover
      sx={{
        '&:last-child td, &:last-child th': { border: 0 },
        transition: 'background-color 0.15s ease',
      }}
    >
      <TableCell padding='checkbox' sx={{ pl: 2, width: 48 }}>
        <Checkbox size='small' />
      </TableCell>
      <TableCell sx={{ py: 1.5 }}>
        <Typography sx={{ fontSize: '0.8125rem', fontWeight: 500, color: 'text.primary' }}>
          {role.roleName}
        </Typography>
      </TableCell>
      <TableCell align='right' sx={{ py: 1.5, pr: 2 }}>
        <Stack direction='row' spacing={1} justifyContent='flex-end' alignItems='center'>
          <PermissionGate requiredPermissions={[Permission.ROLES_EDIT]}>
            <IconButton
              size='small'
              onClick={() => onEditClick(role)}
              sx={{ color: '#059669', '&:hover': { bgcolor: 'rgba(5, 150, 105, 0.08)' } }}
              title='Edit'
            >
              <PencilIcon />
            </IconButton>
          </PermissionGate>
          <PermissionGate requiredPermissions={[Permission.ROLES_DELETE]}>
            <IconButton
              size='small'
              onClick={() => deleteRole(role.id)}
              sx={{ color: '#ef4444', '&:hover': { bgcolor: 'rgba(239, 68, 68, 0.08)' } }}
              title='Delete'
            >
              <TrashIcon />
            </IconButton>
          </PermissionGate>
        </Stack>
      </TableCell>
    </TableRow>
  );
};
